import { render, staticRenderFns } from "./leimu.vue?vue&type=template&id=0511caf5&scoped=true&"
import script from "./leimu.vue?vue&type=script&lang=js&"
export * from "./leimu.vue?vue&type=script&lang=js&"
import style0 from "./leimu.vue?vue&type=style&index=0&id=0511caf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0511caf5",
  null
  
)

export default component.exports